export type BrowserMockConfigCatValue = boolean | number | string;

export type BrowserMockServerEventControls = {
   emitServerEvent: (message: unknown) => void;
};

export type BrowserMockRuntimeState = {
   enabled: true;
   configCatOverrides: Record<string, BrowserMockConfigCatValue>;
   getServerEventControls?: () => BrowserMockServerEventControls;
};

declare global {
   interface Window {
      __DSP_BROWSER_MOCK_RUNTIME__?: BrowserMockRuntimeState;
   }
}

const getBrowserMockRuntimeState = () => {
   if (!__ENABLE_BROWSER_MOCKS__ || typeof window === "undefined") return undefined;

   return window.__DSP_BROWSER_MOCK_RUNTIME__;
};

const serverEventControlsByRuntimeState = new WeakMap<BrowserMockRuntimeState, BrowserMockServerEventControls>();

export const isBrowserMockRuntimeEnabled = () => getBrowserMockRuntimeState()?.enabled === true;

export const getBrowserMockConfigCatOverrides = () => getBrowserMockRuntimeState()?.configCatOverrides;

export const registerBrowserMockServerEventControls = (controls: BrowserMockServerEventControls) => {
   const runtimeState = getBrowserMockRuntimeState();
   if (!runtimeState) {
      throw new Error("Cannot register server-event controls because the browser mock runtime is not enabled");
   }

   runtimeState.getServerEventControls = getBrowserMockServerEventControls;
   serverEventControlsByRuntimeState.set(runtimeState, controls);
};

export const getBrowserMockServerEventControls = () => {
   const runtimeState = getBrowserMockRuntimeState();
   const controls = runtimeState ? serverEventControlsByRuntimeState.get(runtimeState) : undefined;
   if (!controls) {
      throw new Error("Browser mock runtime server-event controls are not registered");
   }

   return controls;
};
